import type { MenuWithStateProps } from '../MenuWithState'

const menuMaxWidth = '400px'

export default (config: { props: Pick<MenuWithStateProps, 'minWidth'> }) => {
  const { props } = config
  return {
    menuWidthHelper: {
      maxWidth: props.minWidth ? undefined : menuMaxWidth,
    },
  } as const
}
